import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { JobSafetyAudit } from './job-safety-audit.model';

export class JobSafetyAuditListItem {
  id: string = '';
  submittedByName: string = '';
  submissionDate: Date | null = null;
  date: Date | null = null;
  callNumber: string = '';
  location: string = '';



  constructor(data?: Partial<JobSafetyAuditListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new JobSafetyAuditListItem();
    const fieldMappings = JobSafetyAudit.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof JobSafetyAuditListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    return columns;
  }

  static fromApiResponse(data: any): JobSafetyAuditListItem {
    return new JobSafetyAuditListItem({
      id: data.id,
      submittedByName: data.submittedByName,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      date: data.date ? new Date(data.date) : null,

      callNumber: data.callNumber,
      location: data.location,

    });
  }
}
